import { createApi } from '@reduxjs/toolkit/query/react';

import { createApiBaseQuery, Methods } from '../shared';

import { AI_BUSINESS_ANALYTICS_CHUNK } from './const';
import {
  AiBusinessAnalyticsEndpoints as Endpoints,
  type AnalyzeBusinessDataRequest,
  type AnalyzeBusinessDataResponse,
} from './types';

export const aiBusinessAnalyticsApi = createApi({
  reducerPath: 'aiBusinessAnalyticsApi',
  baseQuery: createApiBaseQuery(AI_BUSINESS_ANALYTICS_CHUNK),
  endpoints: ({ mutation }) => ({
    [Endpoints.AnalyzeBusinessData]: mutation<
      AnalyzeBusinessDataResponse,
      AnalyzeBusinessDataRequest
    >({
      query: ({ data, ...params }) => {
        const formData = new FormData();

        formData.append('query', data.query);

        if (data.file) {
          formData.append('file', data.file, data.file.name);
        }

        return {
          url: 'analyze-business-data',
          method: Methods.POST,
          params,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        };
      },
    }),
  }),
});

export const { useAnalyzeBusinessDataMutation } = aiBusinessAnalyticsApi;
